/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const getDefaultLinkStyle = (link) => {
    if (link?.is_external) {
        return "external";
    } else {
        return "default";
    }
};

export const LINK_FORMATS = {
    UNDERLINE: "underline-link",
    TEXT: "text-link",
    BULLET_POINT: "bullet-point-link",
    CTA: "cta-link",
};

export const LINK_FORMAT_OPTIONS = [
    { name: "Underline Link", value: LINK_FORMATS.UNDERLINE },
    { name: "Text Link", value: LINK_FORMATS.TEXT },
    { name: "Bullet point", value: LINK_FORMATS.BULLET_POINT },
    { name: "CTA Link", value: LINK_FORMATS.CTA }
];

export const LINK_STYLES = {
    BODY: "body",
    H1: "h1",
    H2: "h2",
    H3: "h3",
};

export const LINK_STYLE_OPTIONS = [
    { name: "Body Text", value: LINK_STYLES.BODY },
    { name: "Heading 1", value: LINK_STYLES.H1 },
    { name: "Heading 2", value: LINK_STYLES.H2 },
    { name: "Heading 3", value: LINK_STYLES.H3 },
];

export const LINK_TARGETS = {
    NEW: "_blank",
    SELF: "_self",
    PARENT: "_parent",
    TOP: "_top",
    DOWNLOAD: "_self", // FIXME: this isn't really a target type
};
